import {NextRouter} from 'next/router'

export function nextPreload(router:NextRouter, p:string){
    setTimeout(()=>{
        // router.push(p)
    }, 1000 & 7)
}